import { render } from "./PregnancyFormModal.vue?vue&type=template&id=1901540e&scoped=true"
import script from "./PregnancyFormModal.vue?vue&type=script&lang=js"
export * from "./PregnancyFormModal.vue?vue&type=script&lang=js"

import "./PregnancyFormModal.vue?vue&type=style&index=0&id=1901540e&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1901540e"]])

export default __exports__